import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import { MemberActivityExportPage } from 'models/Lead';
import ExportMemberActivityForm from './components/ExportMemberActivityForm';

import './ExportMemberActivityModal.styles.scss';

type ExportMemberActivityModalProps = {
  className?: string;
  leadId: string;
  dataRoomDisabled?: boolean;
  memberActivityPage: MemberActivityExportPage;
} & ModalProps;

const ExportMemberActivityModal: React.ForwardRefRenderFunction<
  ModalRef,
  ExportMemberActivityModalProps
> = (props, ref) => {
  const { className, leadId, dataRoomDisabled, memberActivityPage, ...rest } =
    props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('export-member-activity-modal', className);

  const { t } = useTranslation();

  const onCancel = useCallback(() => modal?.close(), [modal]);

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('exportMemberActivity')}
      {...rest}
    >
      <p className="description">{t('chooseInformationToIncludeExport')}</p>

      <ExportMemberActivityForm
        leadId={leadId}
        dataRoomDisabled={dataRoomDisabled}
        memberActivityPage={memberActivityPage}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default forwardRef(ExportMemberActivityModal);
